export default class SelectBox {
    $container: HTMLElement | null | undefined;
    ON_CHANGE = 'change';

    constructor($container: HTMLElement | null) {
        this.$container = $container;
        this.init();
    }

    init() {
        this.updateSummary();
        this.getValue();

        this.$container?.querySelectorAll<HTMLAnchorElement>('ul li a').forEach($anchor => {
            $anchor.addEventListener('click', (event:Event) => {
                event.preventDefault();
                const $currentAnchor = (<HTMLAnchorElement>event.currentTarget);

                this.setValue(<string>$currentAnchor.getAttribute('value'));
                this.close();
                this.$container?.dispatchEvent(new CustomEvent(this.ON_CHANGE, {
                    detail: {
                        value: $currentAnchor.getAttribute('value'),
                        data: $currentAnchor.getAttribute('data')
                    }
                }))
            })
        })
    }

    getValue() {
        const value = this.$container?.getAttribute('value');

        if (value) {
            return value;
        } else {
            this.$container?.setAttribute('value', '0');
            return '0';
        }
    }

    setValue(value: string) {
        this.$container?.setAttribute('value', value);
        this.updateSummary();
    }

    updateSummary() {
        const currentValue = this.$container?.getAttribute('value');
        let test = false;
        this.$container?.querySelectorAll<HTMLAnchorElement>('ul li a').forEach($anchor => {
            if (currentValue === $anchor.getAttribute('value') && !test) {
                test = true;
                (<HTMLElement>(<HTMLElement>this.$container).querySelector('summary .label')).textContent = $anchor.textContent;
            }
        });
    }

    close() {
        (<HTMLElement>this.$container).querySelector<HTMLElement>('details')?.removeAttribute('open');
    }
}
